import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./styles/current.css";
import "./styles/chat.css" 
import "./styles/billStyle.css" 
import 'react-circular-progressbar/dist/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";
//* LAST on purpose: it must land after bootstrap.min.css to win without !important.
import "./styles/brand-modern.css";
//* EXPERIMENT — the dashboard restyle. Delete this one line to revert it entirely.
import "./styles/dashboard-modern.css";

import { install } from "resize-observer";

if (typeof window !== "undefined") {
  install();
}

install();

ReactDOM.render(<App />, document.querySelector("#root"));
